// extracted by mini-css-extract-plugin
module.exports = {"squircle":"IconContainer_squircle___6kn7","circle":"IconContainer_circle__C1MHC","md":"IconContainer_md__r578g"};